module.exports = __webpack_public_path__ + "static/img/10.7628e71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/2/10.png
// module id = uzHS
// module chunks = 0